import {Text, TextProps} from "@mantine/core";
import {processReferences} from "../utils";
import classes from "./ParagraphWithReferences.module.css";

export const ParagraphWithReferences = ({
    children,
    ...props
}: React.PropsWithChildren<TextProps>) => {
    const processedChildren = processReferences(children);
    if (processedChildren === null) {
        return null;
    }
    return (
        <Text {...props} className={classes.paragraph}>
            {processedChildren}
        </Text>
    );
};
